import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';

export function useNavigationBlocker(shouldBlock) {
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [nextLocation, setNextLocation] = useState(null);
  const unblockRef = useRef(null);

  useEffect(() => {
    if (shouldBlock) {
      unblockRef.current = history.block((location) => {
        setShowModal(true);
        setNextLocation(location.pathname);
        return false;
      });
    } else {
      unblockRef.current?.();
    }

    return () => {
      unblockRef.current?.();
    };
  }, [shouldBlock, history]);

  const confirmNavigation = () => {
    if (unblockRef.current) {
      unblockRef.current();
      unblockRef.current = null;
    }
    if (nextLocation) {
      history.push(nextLocation);
    }
  };

  const cancelNavigation = () => {
    setShowModal(false);
    setNextLocation(null);
  };

  return {
    showModal,
    confirmNavigation,
    cancelNavigation,
  };
}